import { Link } from 'react-router-dom';

import RelativeTime from '../relative-time/relative-time';

import './styles/timeline.css';

export default function Timeline({ items, label }) {
    return (
        <ol className="timeline" aria-label={label}>
            {items.map((item) => (
                <li key={item.id} className="timeline__item">
                    <span className={`timeline__marker timeline__marker--${item.tone || 'idle'}`} aria-hidden="true" />
                    <div className="timeline__body">
                        <p className="timeline__meta">
                            <span className="timeline__label">{item.label}</span>
                            <RelativeTime value={item.at} className="timeline__time" />
                        </p>
                        {item.to
                            ? <Link to={item.to} className="timeline__title timeline__title--link">{item.title}</Link>
                            : <p className="timeline__title">{item.title}</p>}
                        {item.actor && <p className="timeline__actor">{item.actor}</p>}
                    </div>
                </li>
            ))}
        </ol>
    );
}
